import { render, staticRenderFns } from "./FileUploadModalForm.vue?vue&type=template&id=f708cbc6"
import script from "./FileUploadModalForm.vue?vue&type=script&lang=js"
export * from "./FileUploadModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports